module.exports = __webpack_public_path__ + "img/0Q3A2496_P_L_WoodMatted_MockedUp.5e23ec76.jpg";